.section {
  min-width: 0;
  scroll-margin-top: calc(4.5rem + env(safe-area-inset-top));
}

.header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.title { margin: 0; }

.allPosts {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
}

.card {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: stretch;
  overflow: hidden;
  color: var(--color-foreground);
  text-decoration: none;
  background: transparent;

  &:hover .postTitle { color: var(--color-primary); }
  &:focus-visible {
    outline: 2px solid var(--color-primary);
    outline-offset: 4px;
  }
}

.artwork {
  position: relative;
  display: grid;
  align-items: center;
  min-width: 0;
  overflow: hidden;
  background: #0e151f;
  border-radius: var(--radius-lg);
}

.cover {
  border-radius: 0;
}

.cardBody {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.875rem;
  padding: 1.5rem 0 0;
}

.postTitle {
  margin: 0;
  font-size: clamp(1.5rem, 2vw, 1.875rem);
  line-height: 1.15;
  letter-spacing: -0.035em;
  text-wrap: balance;
}

.description {
  margin: 0;
  max-width: 34rem;
  font-size: 1rem;
  line-height: 1.6;
}

.readMore {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: auto;
  padding-top: 0.25rem;
}

.arrow {
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: 2.5rem;
  height: 2.5rem;

  color: var(--color-primary);
}

@media (max-width: 760px) {
  .card { grid-template-columns: minmax(0, 1fr); }
  .header { align-items: flex-start; }
}

@media (max-width: 480px) {
  .header { flex-direction: column; }
}

@media (prefers-reduced-motion: reduce) {
  .card { transition: none; }
}
